import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/esm/Button';
import { auth, firestore } from '../../firebase/firebaseConfig';
import { Link } from 'react-router-dom';
import { getDoc, doc, onSnapshot } from "@firebase/firestore";
import { onAuthStateChanged } from 'firebase/auth';

function Otp ( props ) {
    let [ otpInput, setOTPInput ] = useState( "" );

    function codeDigitChange ( event, index ) {
        let value = event.target.value;
        if ( value === "" ) {
            // event.target.style.backgroundColor = "lightgrey";
        } else {
            // event.target.style.backgroundColor = "#117381";
            if ( index !== 6 ) {
                document.querySelectorAll( ".code-input" )[ index ].focus();
            }
        }

        let otp = "";
        document.querySelectorAll( ".code-input" ).forEach( ( element ) => {
            otp += element.value;
        } )
        if ( otp.length === 6 ) {
            setOTPInput( otp );
        }
    }

    async function verifyOTP ( event ) {
        event.preventDefault();
        document.querySelector( ".verifying-otp" ).style.display = "block";
        document.querySelector( ".otp-button" ).setAttribute( "disabled", "" );

        console.log( otpInput );
        window.confirmationResult.confirm( otpInput ).then( async ( result ) => {
            const user = result.user;
            console.log( "Created User - ", user );
            let userDoc = await getDoc( doc( firestore, "users", user.uid ) );
            document.querySelector( ".verifying-otp" ).style.display = "none";
            document.querySelector( ".otp-verified" ).style.display = "block";

            setTimeout( () => {
                document.querySelector( ".otp-verified" ).style.display = "none";
                if ( userDoc.exists() ) {
                    window.location.href = "/";
                } else {
                    document.querySelector( ".user-not-exist" ).style.display = "block";
                    setTimeout( () => {
                        document.querySelector( ".user-not-exist" ).style.display = "none";
                        document.querySelector( ".move-to-signup" ).click();
                    }, 2000 )
                }
            }, 2000 )
        } ).catch( ( error ) => {
            console.log( error );
            document.querySelector( ".verifying-otp" ).style.display = "none";
            document.querySelector( ".otp_authentication_error" ).style.display = "block";
            setTimeout( () => {
                window.location.href = "/login";
            }, 2000 )
        } );
    }

    useEffect( () => {
        document.title = "Laundry Buddy - Verify Your OTP";
        document.querySelector( ".loader-container" ).style.display = "flex";
        onAuthStateChanged( auth, ( user ) => {
            if ( user ) {
                onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
                    if ( snapshot.exists() ) {
                        window.location.href = "/";
                    } else {
                        document.querySelector( ".move-to-signup" ).click();
                    }
                } );
            } else {
                if ( props.phone !== "" ) {
                    document.querySelector( ".loader-container" ).style.display = "none";
                } else if ( props.phone === "" ) {
                    window.location.href = "/login";
                }
            }
        } )
    }, [] );

    return (
        <div className='registration-container'>
            <div className='registration-inner-container'>
                <div className='registration-container-content'>
                    <a className='registration-image laptop' href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-1.webp" )} alt="" /></a>
                    <a className='registration-image mobile' href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-mobile.webp" )} alt="" /></a>
                </div>
                <form className='registration-container-form' onSubmit={event => verifyOTP( event )}>
                    <h3>Get Started</h3>
                    <h6>Enter OTP sent to +91 {props.phone.substring( 0, 10 )}</h6>
                    <div className='code-page-input'>
                        <input type="tel" className='code-input' autoFocus onChange={event => codeDigitChange( event, 1 )} maxLength={1} />
                        <input type="tel" className='code-input' onChange={event => codeDigitChange( event, 2 )} onKeyDown={event => {
                            if ( event.key === "Backspace" && event.target.value === "" ) {
                                document.querySelectorAll( ".code-input" )[ 0 ].focus();
                            }
                        }} maxLength={1} />
                        <input type="tel" className='code-input' onChange={event => codeDigitChange( event, 3 )} onKeyDown={event => {
                            if ( event.key === "Backspace" && event.target.value === "" ) {
                                document.querySelectorAll( ".code-input" )[ 1 ].focus();
                            }
                        }} maxLength={1} />
                        <input type="tel" className='code-input' onChange={event => codeDigitChange( event, 4 )} onKeyDown={event => {
                            if ( event.key === "Backspace" && event.target.value === "" ) {
                                document.querySelectorAll( ".code-input" )[ 2 ].focus();
                            }
                        }} maxLength={1} />
                        <input type="tel" className='code-input' onChange={event => codeDigitChange( event, 5 )} onKeyDown={event => {
                            if ( event.key === "Backspace" && event.target.value === "" ) {
                                document.querySelectorAll( ".code-input" )[ 3 ].focus();
                            }
                        }} maxLength={1} />
                        <input type="tel" className='code-input' onChange={event => codeDigitChange( event, 6 )} onKeyDown={event => {
                            if ( event.key === "Backspace" && event.target.value === "" ) {
                                document.querySelectorAll( ".code-input" )[ 4 ].focus();
                            }
                        }} maxLength={1} />
                    </div>
                    <span className='verifying-otp message hidden'>Verifying OTP ....</span>
                    <span className='otp-verified message hidden'>OTP Verified ....</span>
                    <span className='user-not-exist message-error hidden'>User Doesn't Exist. Kindly Sign Up.</span>
                    <span className='otp_authentication_error message-error hidden'>Wrong Otp Try Again.</span>
                    <Button type="submit" className='otp-button'>Verify</Button>
                    <Link to="/signup" className="move-to-signup">Move</Link>
                </form>
            </div>
        </div>
    )
}

export default Otp